import axios from 'axios';

export function checkToken({ token }) {
    return axios({
        method: 'post',
        url: '/api/v1/tokens/check',
        withCredentials: true,
        data: {
            token,
        }
    });
}




// WEBPACK FOOTER //
// ./app/services/tokens.js